<template>
	<div class="forum-product-discussion">
		<div class="forum-product-discussion-head">
			<i class="fas fa-comments"></i>
			<h6>Forum</h6>
		</div>
		<div class="forum-product-discussion-body">
			<DiscussionBoardView
				v-if="productVariantId"
				scope="productvariant"
				:entity-id="productVariantId"
			/>
		</div>
	</div>
</template>

<script>
import DiscussionBoardView from "../Forum/DiscussionBoardView.vue";

export default {
	name: "ProductContentForum",
	components: { DiscussionBoardView },
	computed: {
		productVariantId() {
			const parsed = parseInt(this.$route.params.id, 10);
			return Number.isNaN(parsed) ? null : parsed;
		},
	},
};
</script>

<style scoped>
.forum-product-discussion {
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	min-height: 100%;
	font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
}

.forum-product-discussion-head {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 14px 22px;
	border-bottom: 1px solid #ececec;
	background-color: #ffffff;
}

.forum-product-discussion-head i {
	color: var(--secondary-color, #0f0f0f);
	font-size: 16px;
}

.forum-product-discussion-head h6 {
	margin: 0;
	font-size: 15px;
	font-weight: 600;
	color: #0f0f0f;
	letter-spacing: -0.01em;
}

.forum-product-discussion-body {
	flex: 1;
	overflow-y: auto;
}

@media (max-width: 600px) {
	.forum-product-discussion-head { padding: 10px 14px; }
	.forum-product-discussion-head h6 { font-size: 14px; }
	.forum-product-discussion-head i { font-size: 14px; }
}
</style>
